import styled from 'styled-components';
import { FormWrapper, OrangeAccentCard } from '../../../styles/listPageTheme';

export const TradingNewWrapper = styled.div`
  background: #0a0e27;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: calc(100% + 3rem);
  max-width: none;
  min-width: 0;
  min-height: calc(100vh - 4.375rem);
  margin: calc(-24px - 1.5rem - 4.375rem) -1.5rem 0 -1.5rem;
  padding-top: calc(4.375rem + 1.5rem);
  padding-bottom: 2rem;
  box-sizing: border-box;
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 32px 16px;

  @media (min-width: 768px) {
    padding: 24px 24px 40px 24px;
  }

  @media (min-width: 1200px) {
    padding: 24px 48px 48px 48px;
  }
`;

/** Mesmo espaçamento que /trading, /bank, etc. */
export const TradingNewFormWrap = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  margin-top: 16px;

  @media (min-width: 576px) {
    margin-top: 20px;
  }

  @media (min-width: 992px) {
    margin-top: 24px;
  }
`;

export const TradingFormCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
  padding: 20px !important;

  @media (min-width: 768px) {
    padding: 32px !important;
  }
`;

export const CardTitle = styled.div`
  color: #f29205;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);

  @media (min-width: 768px) {
    margin-bottom: 24px;
    gap: 10px;
  }

  i {
    font-size: 22px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));

    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
`;

export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root:not(.MuiOutlinedInput-multiline) {
        height: 48px !important;
        min-height: 48px !important;

        .MuiInputBase-input:not(.MuiInputBase-inputMultiline) {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }

      .MuiOutlinedInput-root.MuiOutlinedInput-multiline {
        height: auto !important;
        min-height: 0 !important;

        textarea.MuiOutlinedInput-input {
          min-height: 100px !important;
        }
      }

      .MuiInputLabel-root {
        font-size: 14px !important;
      }

      .MuiButton-root {
        height: 48px !important;
        min-height: 48px !important;
      }
    }
  }
`;

export const PhotoSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const PhotoPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  border: 3px solid rgba(242, 146, 5, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  flex-shrink: 0;

  &:hover {
    border-color: rgba(242, 146, 5, 0.6);
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(242, 146, 5, 0.3);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PhotoInfo = styled.div`
  flex: 1;
  min-width: 250px;

  .photo-label {
    color: #b0b0b0;
    font-size: 14px;
    margin-bottom: 12px;
    display: block;
  }

  .photo-selected {
    color: #00d4ff;
    font-size: 14px;
    margin-top: 12px;
    padding: 8px 12px;
    background: rgba(0, 212, 255, 0.1);
    border-radius: 8px;
    border: 1px solid rgba(0, 212, 255, 0.2);

    strong {
      color: #00d4ff;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
  gap: 12px;

  @media (min-width: 768px) {
    margin-top: 32px;
    padding-top: 24px;
    gap: 16px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;

    > a {
      width: 100%;
      display: block;
    }

    .mobile-button,
    > a .mobile-button,
    > .mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;

      & > span {
        font-size: 14px !important;
      }

      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

export const VisuallyHiddenInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export const CurrencyPairRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;

  > div:first-of-type {
    flex: 1;
    min-width: 200px;
  }
`;

export const AddPairButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 999px;
  border: 2px solid rgba(0, 212, 255, 0.35);
  background: rgba(255, 255, 255, 0.05);
  color: #00d4ff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 2px;

  &:hover {
    background: rgba(0, 212, 255, 0.12);
    border-color: rgba(0, 212, 255, 0.55);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 212, 255, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.25);
  }
`;

export const FormRow = styled.div`
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    margin-bottom: 1.25rem;
  }
`;
